export var MarketingChannel;
(function (MarketingChannel) {
    MarketingChannel["product"] = "product";
    MarketingChannel["updates"] = "updates";
})(MarketingChannel || (MarketingChannel = {}));
export var MarketingSource;
(function (MarketingSource) {
    MarketingSource["shamaazi"] = "shamaazi";
    MarketingSource["mytennights"] = "mytennights";
    MarketingSource["charity"] = "charity";
})(MarketingSource || (MarketingSource = {}));
export var MarketingTransport;
(function (MarketingTransport) {
    MarketingTransport["email"] = "email";
})(MarketingTransport || (MarketingTransport = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0aW5nLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbIm1hcmtldGluZy9tYXJrZXRpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksZ0JBR1g7QUFIRCxXQUFZLGdCQUFnQjtJQUMxQix1Q0FBbUIsQ0FBQTtJQUNuQix1Q0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBSFcsZ0JBQWdCLEtBQWhCLGdCQUFnQixRQUczQjtBQUVELE1BQU0sQ0FBTixJQUFZLGVBSVg7QUFKRCxXQUFZLGVBQWU7SUFDekIsd0NBQXFCLENBQUE7SUFDckIsOENBQTJCLENBQUE7SUFDM0Isc0NBQW1CLENBQUE7QUFDckIsQ0FBQyxFQUpXLGVBQWUsS0FBZixlQUFlLFFBSTFCO0FBRUQsTUFBTSxDQUFOLElBQVksa0JBRVg7QUFGRCxXQUFZLGtCQUFrQjtJQUM1QixxQ0FBZSxDQUFBO0FBQ2pCLENBQUMsRUFGVyxrQkFBa0IsS0FBbEIsa0JBQWtCLFFBRTdCIn0=